import { useQuery } from '@tanstack/react-query';
import { useWalletConnect } from '../hooks/useWalletConnect';
import Button from './ui/Button';
import { getCurrentUser } from '../api/user';

const WalletOverlay = () => {
  const { handleWalletConnect } = useWalletConnect();

  const { data } = useQuery({
    queryKey: ['user'],
    queryFn: getCurrentUser,
    staleTime: 1000 * 30,
  });

  return data?.walletAddress ? null : (
    <div
      className={`
        absolute inset-0 z-50 flex flex-1 items-center justify-center bg-black/40 backdrop-blur-sm
      `}
    >
      <Button
        variant='outlined'
        type='button'
        className='w-5/6'
        onClick={handleWalletConnect}
      >
        Connect a wallet
      </Button>
    </div>
  );
};

export default WalletOverlay;
